class PrintPageSection {
  domRoot: HTMLElement;
  params: any;
  
  constructor(domRoot: HTMLElement, params: any) {
    import(
      /* webpackChunkName: "html2pdf" */
      "js-html2pdf"
    ); // Begin preloading

    this.domRoot = domRoot;
    this.params = params;
    this.init();
  }

  init() {
    this.domRoot
      .querySelector(".print-trigger")
      .addEventListener("click", (e) => {
        e.preventDefault();
        e.target.classList.add("printing");
        var newContainer = document.createElement("div");
        var temps = Array.from(
          document.getElementsByClassName(this.params.printClass)
        );
        temps.forEach((temp) => {
          newContainer.innerHTML += temp.innerHTML;
        });
        var options = {
          margin: 0.5,
          pagebreak: { avoid: ["p", "h1", "h2", "h3", "h4", "h5", "h6", "li"] },
          filename:
            document.title.replace(/ /g, "_").replace(/[^a-zA-Z0-9_]/g, "") +
            ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { scale: 2 },
          jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
        };

        import(
          /* webpackChunkName: "html2pdf" */
          "js-html2pdf"
        ).then((html2pdf) => {
          var exporter = new html2pdf.default(newContainer, options);

          exporter.getPdf(true).then(() => {
            (e.target as HTMLElement).classList.remove("printing");
          });
        });
      });
  }
}

export default PrintPageSection;
